import { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { firebase_auth } from "@src/utility_functions/database_operations/config/firebaseConfig";
import { TextInput } from "@src/components/Forms/FormElements/Inputs/TextInput";
import { validateInput } from "@src/utility_functions/inputValidation/validateInput";
import { validateEmail } from "#shared/inputValidation/inputValidation.js";
import { useModal } from "@src/utility_functions/customHooks/useModal";

export const ForgotPasswordModal = (props) => {
  const { setModalContent } = useModal();
  const [emailError, setEmailError] = useState("");
  return (
    <>
      <div className="_display--flex _flex-direction--column">
        <form
          noValidate={true}
          onSubmit={async (event) => {
            event.preventDefault();
            event.stopPropagation();
            const formData = new FormData(event.currentTarget);
            const formDataEntries = Object.fromEntries(formData.entries());
            const emailValid =
              validateEmail(formDataEntries.email).errorClass === "valid";
            if (emailValid) {
              try {
                await sendPasswordResetEmail(
                  firebase_auth,
                  String(formDataEntries.email),
                );
                //updateResetPasswordEmailLinkLastSentTime()
                setModalContent({
                  modalTitle: "Forgot Password",
                  dialogWidth: "50%",
                  modalContent: (
                    <SendPasswordResetSuccess email={formDataEntries.email} />
                  ),
                });
                if (props.setPasswordResetTimer) {
                  props.setPasswordResetTimer(120);
                }
              } catch (error) {
                console.warn(error);
              }
            } else {
              validateInput(
                formDataEntries.email,
                validateEmail,
                setEmailError,
              );
            }
          }}
        >
          <div className="_text-align--center _margin-bottom--1rem">
            <p>
              Enter your email and we will send you a link to reset your
              password
            </p>
          </div>
          <div className="_margin-bottom--1rem">
            <TextInput
              inputId="resetPasswordEmailInput"
              inputType="email"
              name="email"
              labelText="Email"
              maxlength={50}
              defaultValue=""
              placeholder="Email"
              autocomplete="email"
              required={true}
              validationResponse={emailError}
              onChangeFunction={(event: React.FocusEvent<HTMLInputElement>) => {
                validateInput(event.target.value, validateEmail, setEmailError);
              }}
            />
          </div>
          <button className="btn btn--primary _width--100percent" type="submit">
            Send Reset Password Link
          </button>
        </form>
      </div>
    </>
  );
};

export const SendPasswordResetSuccess = (props) => {
  return (
    <>
      <div className="_text-align--center">
        <p className="_font-size--3rem">📧</p>
        <p className="_margin-bottom--1rem">Success!</p>
        <p>
          We have sent a password reset email to <b>{props.email}</b>
        </p>
      </div>
    </>
  );
};
